import React from "react"
import PropTypes from "prop-types"
import Icon from '../app_components/Icon'
import { semantic } from '@lexody/design-tokens'

class MenuItem extends React.Component {
  render() {
    const hasIcon = Boolean(this.props.icon)
    const iconColor = this.props.iconColor || semantic.primary.text.label

    return(
      <div
        className={hasIcon ? 'menuItem menuItem-withIcon' : 'menuItem'}
        onClick={() => this.props.onClick()}>
        {hasIcon ? (
          <Icon
            name={this.props.icon}
            size={20}
            color={iconColor}
            style={{ flexShrink: 0 }}
          />
        ) : (
          <div className={this.props.iconName}></div>
        )}
        <h5>{this.props.title}</h5>
      </div>
    )
  }
}

export default MenuItem;
